import React from 'react';

export type LoadingButtonProps = { isLoading?: boolean };

function LoadingButton({
    isLoading = false,
    disabled,
    children,
    ...rest
}: LoadingButtonProps & React.ComponentPropsWithRef<'button'>) {
    const disabledProp = isLoading ? true : disabled;

    return (
        // eslint-disable-next-line react/button-has-type
        <button disabled={disabledProp} {...rest}>
            {children}
            {isLoading ? (
                <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true" />
            ) : null}
        </button>
    );
}

export default LoadingButton;
